module.exports = {
	"articleTitle1": "North Campus's Duderstadt Center is more than a library",
	"catImage": "bluestar.png",
	"totalCats": 2,
	"name": "Duderstadt Center (Dude)",
	"articleLink1": "#",
	"articleLink2": "http://www.michigandaily.com/arts/architecture-bside-part-2",
	"articleSnippet1": "Mar 30, 2011 ... The Duderstadt Center on North Campus encapsulates a multitude of identities. \nThe building — affectionately known as “The Dude” — is a ...",
	"articleSnippet2": "Mar 30, 2011 ... ... Dennison places functionality over aesthetics • THE DIVERSIFIED DUDE: \nNorth Campus's Duderstadt Center is more than a library.",
	"totalMisc": 1,
	"articleTitle2": "Merging diversity and harmony in the Angell Hall complex",
	"address": "2281 Bonisteel Blvd, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.2912,
		"lng": -83.7157
	},
	"tips": [
		{
			"text": "The Dude is great if you really need to be productive. There aren't too many distractions on the 2nd and 3rd floors.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 3,
			"bathroom": "1st Floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"studyspot": 1,
		"location": 1,
		"library": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/duderstadt.json
// module id = 866
// module chunks = 0